import { makeStyles } from '@material-ui/core';

import { neutral, orange } from 'shared/styles/colors';
import {
  SHIMMER_GRADIENT,
  shimmerKeyframes,
} from '../../shared/styles/shimmer';

const shimmer = {
  background: SHIMMER_GRADIENT,
  backgroundSize: '200% 100%',
  animation: '$shimmer 1.4s ease infinite',
};

export default makeStyles({
  ...shimmerKeyframes,
  skeletonCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    padding: '1.0625rem',
    backgroundColor: neutral.white,
    border: `1px solid ${orange.D7}`,
    borderRadius: '0.625rem',
    overflow: 'hidden',
  },
  skeletonHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '0.5rem',
  },
  skeletonIdentity: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.375rem',
    flex: '1 1 0',
    minWidth: 0,
  },
  skeletonTag: {
    width: '9.5rem',
    height: '1.5rem',
    borderRadius: '1.25rem',
    flexShrink: 0,
    ...shimmer,
  },
  skeletonLine: {
    borderRadius: '0.25rem',
    ...shimmer,
    height: '0.875rem',
  },
  skeletonLineLong: {
    width: '60%',
  },
  skeletonLineShort: {
    width: '25%',
  },
  skeletonLineMedium: {
    width: '45%',
  },
  skeletonDateRow: {
    display: 'flex',
    gap: '0.375rem',
    alignItems: 'center',
  },
  skeletonIcon: {
    width: '1rem',
    height: '1rem',
    borderRadius: '50%',
    ...shimmer,
    flexShrink: 0,
  },
});
